import type { WPathTranslations } from "./pl";

export const en: WPathTranslations = {
  ariaLabel: "Breadcrumb",
};
